export function findAuthorization (authCode) {
  const employeeMenuList = localStorage.getItem('employeeMenuList') ? JSON.parse(localStorage.getItem('employeeMenuList')) : [];
  if (authCode) {
    return employeeMenuList.findIndex(item => item.authCode === authCode) !== -1 || false;
  }
  return false;
}
